import defineCustomElement from '../../define-custom-element.js';
import TpPopup from './tp-popup.js';
import TpMenuEdge from './tp-menu-edge.js';
import TpMenu from './tp-menu.js';

defineCustomElement('tp-menu', TpMenu, TpMenuEdge);

export {
  TpMenu,
  TpPopup
}
